var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckVer2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_314_2002",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_314_2002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55001 15.5154L18.1885 6.87695C18.3372 6.72823 18.5138 6.65226 18.7183 6.64905C18.9228 6.64585 19.1026 6.72181 19.2577 6.87695C19.4128 7.03206 19.4904 7.21026 19.4904 7.41155C19.4904 7.61281 19.4128 7.79101 19.2577 7.94615L10.1827 17.0211C10.0019 17.2019 9.79102 17.2923 9.55001 17.2923C9.30899 17.2923 9.0981 17.2019 8.91733 17.0211L4.74233 12.8461C4.59361 12.6974 4.52021 12.5208 4.52213 12.3163C4.52406 12.1119 4.60259 11.9321 4.75771 11.7769C4.91284 11.6218 5.09104 11.5442 5.29231 11.5442C5.49359 11.5442 5.67179 11.6218 5.82691 11.7769L9.55001 15.5154Z",
    fill: "#2D87F3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckVer2);
export default __webpack_public_path__ + "static/media/CheckVer2.dd1af99f2f7e4c43997b8d34e040585e.svg";
export { ForwardRef as ReactComponent };